import toast from "react-hot-toast";
import { usePublishReportMicroserviceOutboxEventMutation } from "../../../services/clientreports";

export type PublishMessageEventValues = {
    publishEvent: (eventId: number) => void
};

export const usePublishMessageEvent = () : PublishMessageEventValues => {
    const [_mutate] = usePublishReportMicroserviceOutboxEventMutation();
    
    const onHandlePublishEvent = (eventId: number) => {
        _mutate(eventId).unwrap().then(
            () => toast('Event published succesfully.'),
            () => toast.error('Failed to publish event.')
        );
    };

    return {
        publishEvent: onHandlePublishEvent
    };
};